// extracted by mini-css-extract-plugin
module.exports = {"container":"FullScreenWrapper_container__27iy_"};